import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl'
import { each, map } from 'lodash'

import { callApi } from '../services/fetchService'
import { loadGlobals, closePatientRecord } from '../actions'

import DataTable from '../components/DataTable'
import FaIcon from '../components/FaIcon'
import TableButton from '../components/TableButton'

import { message, Modal } from 'antd'
const confirm = Modal.confirm



class Users extends Component {

    state = {
        data: [],
        loading: false
    }

    static propTypes = {
        loadGlobals: PropTypes.func.isRequired,
        closePatientRecord: PropTypes.func.isRequired,
        comboboxes: PropTypes.object.isRequired,
        session: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }

    fetch = (params = {}) => {
        const { intl, comboboxes } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'users'
        }).then((data) => {
            this.setState({
                data: each(data, (item) => {
                    item.fullName = item.lastName + ' ' + item.firstName
                    item.addressCountry = comboboxes.byKey.country[item.addressCountry].value
                    item.language = comboboxes.byKey.language[item.language].value
                    item.permissions = map(item.permissions, (item) => comboboxes.byKey.permission[item].value)
                    item.permissions = item.permissions.join(', ')
                }),
                loading: false
            })
        }).catch((err) => {
            message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            this.setState({ loading: false })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    block = (doctor) => {
        const { intl } = this.props
        callApi({
            endpoint: 'users/' + doctor.id + '/block',
            method: 'POST'
        }).then((data) => {
            message.success(intl.formatMessage({ id: 'users.blocked' }))
            this.fetch();
        }).catch((data) => {
            if (data.code === 8) {
                message.warn(intl.formatMessage({ id: 'users.unableToSelfBlock' }))
            } else {
                message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            }
        })
    }

    unblock = (doctor) => {
        const { intl } = this.props
        callApi({
            endpoint: 'users/' + doctor.id + '/unblock',
            method: 'POST'
        }).then((data) => {
            message.success(intl.formatMessage({ id: 'users.unblocked' }))
            this.fetch()
        }).catch((data) => {
            if (data.code === 9) {
                message.warn(intl.formatMessage({ id: 'users.unableToSelfUnblock' }))
            } else {
                message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            }
        })
    }

    blockAddConsultations = (doctor) => {
        const { intl } = this.props
        callApi({
            endpoint: 'users/' + doctor.id + '/blockAddConsultations',
            method: 'POST'
        }).then((data) => {
            message.success(intl.formatMessage({ id: 'users.blocked' }))
            this.fetch();
        }).catch((data) => {
            if (data.code === 8) {
                message.warn(intl.formatMessage({ id: 'users.unableToSelfBlock' }))
            } else {
                message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            }
        })
    }

    unblockAddConsultations = (doctor) => {
        const { intl } = this.props
        callApi({
            endpoint: 'users/' + doctor.id + '/unblockAddConsultations',
            method: 'POST'
        }).then((data) => {
            message.success(intl.formatMessage({ id: 'users.unblocked' }))
            this.fetch()
        }).catch((data) => {
            if (data.code === 9) {
                message.warn(intl.formatMessage({ id: 'users.unableToSelfUnblock' }))
            } else {
                message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            }
        })
    }

    delete = (doctor) => {
        const { intl } = this.props
        callApi({
            endpoint: 'users/' + doctor.id,
            method: 'DELETE'
        }).then((data) => {
            message.success(intl.formatMessage({ id: 'misc.deleteSuccess' }))
            this.fetch()
            loadGlobals()
            if (this.props.patient && this.props.patient.doctor === doctor.id) {
                this.props.closePatientRecord();
            }
        }).catch((data) => {
            if (data.code === 9) {
                message.warn(intl.formatMessage({ id: 'users.unableToSelfDelete' }))
            } else {
                message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            }
        })
    }

    confirmDelete = (doctor) => {
        const { intl } = this.props
        const self = this
        confirm({
            title: intl.formatMessage({ id: 'misc.confirm2' }),
            okText: intl.formatMessage({ id: 'misc.deleteCaps' }),
            okType: 'danger',
            content: intl.formatMessage({ id: 'users.confirmDelete' }),
            onOk() {
                return self.delete(doctor)
            },
            onCancel() { }
        })
    }

    rowsConfig = (record) => ({
        style: { cursor: 'pointer' },
        onClick: (e) => {
            if (this.props.session.user.id === record.id) {
                this.props.history.push('/profile')
            } else {
                this.props.history.push('/user/' + record.id)
            }
        }
    })

    render() {
        const { data, loading } = this.state

        const columns = [
            { title: "users.nameColumn", dataIndex: "fullName", type: "string", sorter: true },
            { title: "users.emailColumn", dataIndex: "email", type: "string", sorter: true },
            { title: "users.countryColumn", dataIndex: "addressCountry", type: "string", sorter: true },
            { title: "users.languageColumn", dataIndex: "language", type: "string", sorter: true },
            { title: "users.permissionsColumn", dataIndex: "permissions", type: "string", sorter: true },
            { title: "users.activeColumn", dataIndex: "blocked", type: "boolean", inverted: true },
            {
                title: "misc.actions", width: "120px", key: "action", render: (record) => (
                    <span>
                        {record.blocked
                            ? <TableButton color="green" icon="user-unlock" onClick={this.unblock} value={record} confirm tip={<FormattedMessage id="doctors.unblockTooltip" />} />
                            : <TableButton color="red" icon="user-lock" onClick={this.block} value={record} confirm tip={<FormattedMessage id="doctors.blockTooltip" />} />
                        }
                        {record.canAddConsultations
                            ? <TableButton color="red" icon="lock-alt" onClick={this.blockAddConsultations} value={record} confirm tip={<FormattedMessage id="doctors.blockAddConsultationsTooltip" />} />
                            : <TableButton color="green" icon="unlock-alt" onClick={this.unblockAddConsultations} value={record} confirm tip={<FormattedMessage id="doctors.unblockAddConsultationsTooltip" />} />
                        }
                        <TableButton color="red" icon="trash-alt" onClick={this.confirmDelete} value={record} confirm />
                    </span>

                )
            }
        ]

        return (
            <div>
                <h1><FaIcon icon="users" fixedWidth /> <FormattedMessage id="users.title" /></h1>
                <DataTable columns={columns} dataSource={data} loading={loading} rowKey="id" size="middle" onRow={this.rowsConfig} />
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    comboboxes: state.comboboxes,
    session: state.session,
    patient: state.patient
})

export default withRouter(injectIntl(connect(mapStateToProps, {
    loadGlobals,
    closePatientRecord
})(Users)))


// WEBPACK FOOTER //
// ./src/views/Users.js